import {
  GET_AD_GROUP_STICKY_COLUMNS,
  GET_AD_GROUP_STICKY_COLUMNS_SUCCESS,
  GET_AD_GROUP_STICKY_COLUMNS_ERROR,
  UPDATE_AD_GROUP_STICKY_COLUMNS,
  UPDATE_AD_GROUP_STICKY_COLUMNS_SUCCESS,
  UPDATE_AD_GROUP_STICKY_COLUMNS_ERROR
} from "./actionTypes"

// FOR GET ADMIN USER ROLE
export const getAdgroupStickyColumns = () => {
  return {
    type: GET_AD_GROUP_STICKY_COLUMNS,
  }
}

export const getAdgroupStickyColumnsSuccess = sticky_columns => {
  return {
    type: GET_AD_GROUP_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const getAdgroupStickyColumnsError = error => {
  return {
    type: GET_AD_GROUP_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}

// FOR UPDATE ADMIN USER ROLE
export const updateAdgroupStickyColumns = (sticky_columns) => {
  return {
    type: UPDATE_AD_GROUP_STICKY_COLUMNS,
    payload: sticky_columns,
  }
}

export const updateAdgroupStickyColumnsSuccess = sticky_columns => {
  return {
    type: UPDATE_AD_GROUP_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
  }
}

export const updateAdgroupStickyColumnsError = error => {
  return {
    type: UPDATE_AD_GROUP_STICKY_COLUMNS_ERROR,
    payload: error,
  }
}